var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 28.18",
    style: {
      enableBackground: "new 0 0 22 28.18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.66,5.63H3.34c-1.71,0-3.11,1.39-3.11,3.11v10.7c0,1.71,1.39,3.11,3.11,3.11h15.32 c1.71,0,3.11-1.39,3.11-3.11V8.74C21.77,7.03,20.37,5.63,18.66,5.63z M18.66,7.12c0.13,0,0.25,0.02,0.37,0.04l-6.46,7.33 c-0.4,0.45-0.97,0.71-1.57,0.71c-0.6,0-1.17-0.26-1.57-0.71L2.97,7.16c0.12-0.03,0.24-0.04,0.37-0.04H18.66z M20.28,19.44 c0,0.89-0.73,1.62-1.62,1.62H3.34c-0.89,0-1.62-0.73-1.62-1.62V8.74c0-0.22,0.04-0.43,0.12-0.62l6.48,7.35 C9,16.25,9.97,16.69,11,16.69s2-0.44,2.68-1.21l6.48-7.35c0.08,0.19,0.12,0.4,0.12,0.61V19.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ebe09dcda127eea828b5e520b4115f27.svg";
export { ForwardRef as ReactComponent };